import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function ColorSwatch({ color, isSelected, name, onChange, value }) {
  const colorSwatchClasses = classNames('color-swatch', {
    'color-swatch--selected': !!isSelected,
  });

  return (
    <label className="color-swatch__container">
      <input
        checked={isSelected}
        className="visually-hidden"
        name={name}
        onChange={onChange}
        type="radio"
      />
      <div className={colorSwatchClasses} style={{ backgroundColor: color }} />
      <div className="color-swatch__name subheading--mini">
        {value || color}
      </div>
    </label>
  );
}

ColorSwatch.propTypes = {
  color: PropTypes.string,
  isSelected: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string.isRequired,
};

ColorSwatch.defaultProps = {
  color: '#000',
  onChange: () => {}, // eslint-disable-line no-empty-function
};

export default ColorSwatch;
